<div class="controls-container">
    <div class="controls-header">Tooltip</div>

    <div class="controls-sub-header" style="background: gray; color: white; width: 130px; margin: 2px; padding: 5px; cursor: default;" [tooltip]="tooltip">Simple tooltip</div>
    <pm-tooltip #tooltip [Content]="TooltipContent" ></pm-tooltip>

    <div class="controls-sub-header" style="background: gray; color: white; width: 350px; margin: 2px; padding: 5px; cursor: default;" [tooltip]="longerTooltip">Wider Tooltip with longer delay/duration</div>
    <pm-tooltip #longerTooltip [Content]="TooltipContent" [Width]="350" [Delay]="2000" [Duration]="10000" ></pm-tooltip>

    <div class="controls-sub-header" [tooltip]="tooltip">Tooltip options:</div>
    <pm-check-box [style.padding.px]="5" [(IsChecked)]="showTooltip" Label="Enable tooltip button"></pm-check-box>        
    <pm-radio-button *ngFor="let item of DefaultItems"
        [style.padding.px]="5"
        [(RadioGroup)]="DefaultGroup"
        [Value]="item.Value"
        [Label]="item.Label"
        [(IsChecked)]="item.IsChecked"
        [IsDisabled]="item.IsDisabled">
    </pm-radio-button>
    <pm-button style="position:relative; left: 20px; top: 20px;" [tooltip]="buttonTooltip">Button with Tooltip</pm-button>
    <pm-tooltip #buttonTooltip [EnableTooltip]="showTooltip" [Content]="DefaultGroup"></pm-tooltip>

</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/tool-tip/tool-tip.html